import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import ServiceCard from "../components/ServiceCard";
import { serviceGroups, services, site } from "../data/site";

export default function ServicesPage() {
  return (
    <>
      <SEO
        title="Stone Polishing Services Singapore | Marble, Granite, Quartz, Terrazzo"
        description="Browse Polishing Singapore service pages for marble, granite, quartz, terrazzo, tile and grout, parquet, concrete and natural stone care."
        canonical={`${site.domain}/services`}
      />
      <PageHero title="Stone Polishing and Restoration Services" description="Material-specific polishing, cleaning, repair, restoration and maintenance pages for Singapore homes and commercial spaces." image={site.heroImages[1]} />

      <section className="section-pad bg-background-50">
        <div className="section-shell space-y-14">
          {serviceGroups.map((group) => {
            const groupServices = services.filter((service) => service.category === group.name);
            return (
              <section key={group.slug} id={group.slug} className="scroll-mt-28">
                <div className="mb-6 grid gap-6 lg:grid-cols-[0.75fr_1fr] lg:items-end">
                  <div>
                    <p className="eyebrow">{group.name}</p>
                    <h2 className="mt-3 font-heading text-4xl font-bold">{group.name} Services</h2>
                    <p className="mt-4 text-base leading-8 text-foreground-700">{group.intro}</p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {group.services.map((service) => (
                      <Link key={service.slug} to={`/services/${service.slug}`} className="rounded-full border border-background-300 bg-white px-4 py-2 text-sm font-semibold text-foreground-700 hover:border-primary-300 hover:text-primary-700">
                        {service.title}
                      </Link>
                    ))}
                  </div>
                </div>
                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                  {groupServices.map((service) => (
                    <ServiceCard key={service.slug} {...service} />
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </section>
    </>
  );
}
